'use client'
import SegmentDetailPanel from './SegmentDetailPanel';
import SegmentPreviewPanel from './SegmentPreviewPanel';
import SegmentTimeline from './SegmentTimeline';
import ProjectMenuBar from './ProjectMenuBar';
import SegmentTaskMonitor from './SegmentTaskMonitor';

const sectionPaddingClass = 'px-2 md:px-3 xl:px-4'

export const StoryboardWorkspace: React.FC = () => (
  <div className="flex flex-col flex-1 min-h-0">
    <SegmentTaskMonitor />
    <div className="flex-1 min-h-0 rounded border bg-background/80 flex flex-col overflow-hidden">
      <div className={`${sectionPaddingClass} py-1.5 md:py-2 xl:py-0.5 border-b`}>
        <ProjectMenuBar />
      </div>

      <div className={`flex-1 min-h-0 ${sectionPaddingClass} py-1.5 md:py-2.5 xl:py-3 flex flex-col gap-3 md:gap-4`}>
        <div className="flex-none">
          <SegmentPreviewPanel />
        </div>
        <div className="flex-1 min-h-0">
          <SegmentTimeline />
        </div>
        <div className="flex-[0.8] min-h-0 flex flex-col">
          <SegmentDetailPanel />
        </div>
      </div>
    </div>
  </div>
);

export default StoryboardWorkspace;
